import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { MetricProps } from '../../utils';
import { FunctionData } from '@hud/portal-dtos/webapp-function.dto';
import { Endpoint } from '@hud/portal-dtos/webapp-endpoint.dto';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { MessageQueue } from '@hud/portal-dtos/webapp-message-queue.dto';
import { DotLoader } from '@hud/web-components/Loader/DotLoader';
import { TextTooltip } from '@hud/web-components/TextTooltip/TextTooltip';
import styled from 'styled-components';
import { formatFunctionMetric } from './functionMetricCellRenderer';

const EMPTY_METRIC_CELL_TOOLTIP =
  'P90 metrics typically become available a few minutes after installation.';

export default function p90RenderFunctionMetric<
  TData extends FunctionData | Endpoint | MessageQueue,
  TValue extends number,
>(format: MetricProps['format']) {
  const formatMetric = formatFunctionMetric<TData>(format);
  return function cellRenderer(cell: CellContext<TData, TValue>) {
    // 0 means no data available, but we only show the empty cell if there are runs but the p90 has not been calculated yet
    if (cell.getValue() === 0 && cell.row.original.metrics.runs.value > 0) {
      return <EmptyMetricCell />;
    }
    const normalized = formatMetric(cell);
    return <LongContentPopover>{normalized}</LongContentPopover>;
  };
}

function EmptyMetricCell() {
  return (
    <TextTooltip label={<TooltipContainer>{EMPTY_METRIC_CELL_TOOLTIP}</TooltipContainer>}>
      <EmptyMetricCellContainer>
        <DotLoader />
      </EmptyMetricCellContainer>
    </TextTooltip>
  );
}

const EmptyMetricCellContainer = styled.div`
  /* text-align: center; */
`;

const TooltipContainer = styled.div`
  width: 250px;
  text-align: center;
  word-break: break-word;
  white-space: normal;
`;
